module.exports = __webpack_public_path__ + "static/media/logo.5cc78b48.png";